import{a as i}from"./ninox-components-PWW3TNA5.js";import{l as e}from"./ninox-components-GQTCIGTF.js";import n from"styled-components";var l=n.span`
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;

    line-height: 1;

    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    letter-spacing: normal;
    text-transform: none;
    user-select: none;
    pointer-events: none;
    text-decoration: none;

    font-family: ${({fontFamily:t})=>t||"Material Symbols Rounded"}, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
    overflow: hidden;

    max-width: ${({size:t})=>t||e.sm};
    font-size: ${({size:t})=>t||e.sm};
    font-weight: ${({weight:t})=>t??i.weight};
    font-variation-settings: ${({filling:t})=>`'FILL' ${t??0}`};
`;export{l as a};
//# sourceMappingURL=ninox-components-II7ZJATT.js.map